import React, { useEffect, useState } from "react";
import { MainCard } from "../components/Card/Cards";
import Table from "../components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { hidePageLoader } from "../utils/javascript";
import { getContactFormList } from "../store/Slices/contactFormSlice";
import { Sidebar } from "primereact/sidebar";
import { FaRegEye } from "react-icons/fa";
export default function QuoteRequests() {
  const dispatch = useDispatch();
  const [active, setActive] = useState(null);
  const contactForms = useSelector((state) => state?.contactForm?.list);

  let columns = [
    {
      field: "name",
      header: "Name",
    },
    {
      field: "email",
      header: "Email",
    },
    {
      field: "createdAt",
      header: "Date/Time",
      body: (col) => col?.createdAt.split("T")?.join(" "),
    },
    {
      field: "",
      header: "Action",
      body: (col) => (
        <FaRegEye className="cursor-pointer" onClick={() => setActive(col)} />
      ),
    },
  ];
  useEffect(() => {
    dispatch(getContactFormList({ hidePageLoader }));
  }, [dispatch]);
  return (
    <div className="p-3">
      <Sidebar
        header={
          <p>
            <b>Date -</b>
            <span> {active?.createdAt}</span>
          </p>
        }
        visible={active !== null}
        onHide={() => setActive(null)}
        className="w-full md:w-20rem lg:w-30rem"
        position="right"
      >
        <p>
          <b>Subject -</b>
          <span> {active?.subject}</span>
        </p>

        <p>
          <b>Name -</b>
          <span> {active?.name}</span>
        </p>
        <p>
          <b>Email -</b>
          <span> {active?.email}</span>
        </p>
        <p>
          <b>Phone No. -</b>
          <span> {active?.phone}</span>
        </p>
        <p>
          <b>Message -</b>
          <span> {active?.message}</span>
        </p>
      </Sidebar>
      <h3>Quote Requests</h3>
      <MainCard>
        <Table columns={columns} data={contactForms} />
      </MainCard>
    </div>
  );
}
